import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MeetingFileDto } from '@shared/interfaces/dtos/meetings';
import { BaseHttpService } from './base-http.service';
import { UpdateMeetingFile } from '@shared/interfaces/meetings';

@Injectable({
  providedIn: 'root',
})
export class PointFilesService extends BaseHttpService {
  protected readonly endPoint: string = 'Points';

  public fetchPointFiles(pointId: number): Observable<MeetingFileDto[]> {
    return this.http.get<MeetingFileDto[]>(this.buildURL({ idOrSubEndpoint: `${pointId}/Files` }));
  }

  public uploadPointFiles(pointId: number, files: File[], asAttachement: boolean = false): Observable<unknown> {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append(`file ${index}`, file, file.name);
    });

    return this.http.post<unknown>(this.buildURL({ idOrSubEndpoint: `${pointId}/MultipleFiles` }), formData, {
      params: { annexe: asAttachement },
    });
  }

  public downloadPointFile(pointId: number, fileId: number): Observable<Blob> {
    return this.http.get<Blob>(this.buildURL({ idOrSubEndpoint: `${pointId}/Files/${fileId}/Download` }), {
      responseType: 'blob' as 'json',
    });
  }

  public setPointFilesVisibility(
    pointId: number,
    filesIds: number | number[],
    visibility: {
      visibleForRepresentatives?: boolean;
      visibleForCitizens?: boolean;
    }
  ): Observable<unknown> {
    const targets = Array.isArray(filesIds) ? filesIds : [filesIds];

    const body = targets.map((fileId) => ({
      fileId,
      visibleDelibeWeb: visibility.visibleForRepresentatives,
      visibleDelibeWebCitoyen: visibility.visibleForCitizens,
    }));

    return this.http.patch<unknown>(this.buildURL({ idOrSubEndpoint: `${pointId}/Files` }), body);
  }

  public updatePointFile(pointId: number, fileId: number, body: UpdateMeetingFile): Observable<unknown> {
    return this.http.patch<unknown>(this.buildURL({ idOrSubEndpoint: `${pointId}/Files/${fileId}` }), body);
  }

  public deletePointFile(pointId: number, fileId: number): Observable<unknown> {
    return this.http.delete<unknown>(this.buildURL({ idOrSubEndpoint: `${pointId}/Files/${fileId}` }));
  }
}
